import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { HeicPreviewService, isHeicImage } from './heic-preview.service';

/** Converts HEIC thumbnails while leaving browser-native image URLs intact. */
@Directive({
  selector: 'img[previewImageSrc]',
  standalone: true
})
export class ImagePreviewDirective implements OnChanges, OnDestroy {
  @Input() previewImageSrc: string | null | undefined;
  private request = new AbortController();
  private objectUrl: string | undefined;

  constructor(
    private readonly image: ElementRef<HTMLImageElement>,
    private readonly previews: HeicPreviewService
  ) {}

  ngOnChanges(): void {
    this.releasePreview();
    const source = this.previewImageSrc;
    if (!source) return;
    if (isHeicImage(source)) {
      const request = new AbortController();
      this.request = request;
      void this.loadPreview(source, request.signal);
    } else {
      this.image.nativeElement.src = source;
    }
  }

  ngOnDestroy(): void {
    this.releasePreview();
  }

  private async loadPreview(
    source: string,
    signal: AbortSignal
  ): Promise<void> {
    try {
      const preview = await this.previews.createPreview(source, signal);
      if (signal.aborted) return;
      this.objectUrl = URL.createObjectURL(preview);
      this.image.nativeElement.src = this.objectUrl;
    } catch {
      if (!signal.aborted) {
        // Keep each view's existing image-error fallback for failed conversions.
        this.image.nativeElement.dispatchEvent(new Event('error'));
      }
    }
  }

  private releasePreview(): void {
    this.request.abort();
    this.image.nativeElement.removeAttribute('src');
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = undefined;
    }
  }
}
